<template>
  <div class="content"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-breadcrumbs :items="page" class="ml-2 my-2 mt-0 pt-0"></v-breadcrumbs>
      <v-stepper v-model="e1" flat class="mx-6">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Step 1</v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">
            Step 2
          </v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3">
            Step 3
          </v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 4" step="4">
            Step 4
          </v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 5" step="5">
            Step 5
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card flat class="mb-12" height="150px">
              <v-card-title style="font-size:16px;"><span style="color: #0471A5;">Pilih Langkah yang Anda Inginkan</span></v-card-title>
                <v-radio class="ml-2" label="Menambah Keyword Baru" color="blue"></v-radio>
                <v-radio class="ml-2 mt-2" label="Mengubah Keyword atau Menghapus Keyword" color="blue"></v-radio>
              </v-card>

              <v-divider></v-divider>
              <div class="mt-4">
                <v-btn disabled class="mx-2" outlined rounded color="primary">Previous</v-btn>
                <v-btn rounded color="primary" @click="e1 = 2">Continue</v-btn>
              </div>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card flat height="300px">
              <v-card-title style="font-size:16px;"><span style="color: #0471A5;">Pilih Role yang diingikan atau tambah Role baru</span></v-card-title>
              <v-radio class="ml-2" label="Saya ingin gunakan role yang sudah ada" color="blue"></v-radio>
              <v-col cols="12" sm="3" md="3">
                <v-select label="Keyword Status" dense outlined :items="role" value="Enabled"></v-select>
              </v-col>

              <v-radio class="ml-2" label="Saya ingin masukan nama untuk role baru" color="blue"></v-radio>
              <v-col cols="12" sm="3" md="3">
                <v-text-field outlined dense label="Keyword ID" hint="*required" persistent-hint></v-text-field>
              </v-col>
            </v-card>

            <v-divider></v-divider>
            <div class="mt-4">
              <v-btn class="mx-2" outlined rounded color="primary" @click="e1 = 1">Previous</v-btn>
              <v-btn rounded color="primary" @click="e1 = 3">Continue</v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card flat height="300px">
              <v-card-title style="font-size:16px;"><span style="color: #0471A5;">Pilih Keywrod group yang diingikan atau tambah Keyword group baru</span></v-card-title>
              <v-radio class="ml-2" label="Saya ingin gunakan group keyword yang sudah ada" color="blue"></v-radio>
              <v-col cols="12" sm="3" md="3">
                <v-select label="Group Keyword" dense outlined :items="groupkeyword" value="Bencana"></v-select>
              </v-col>

              <v-radio class="ml-2" label="Saya ingin masukan nama untuk keyword group baru" color="blue"></v-radio>
              <v-col cols="12" sm="3" md="3">
                <v-text-field outlined dense label="Keyword Group Baru"></v-text-field>
              </v-col>
            </v-card>

            <v-divider></v-divider>
            <div class="mt-4">
              <v-btn class="mx-2" outlined rounded color="primary" @click="e1 = 2">Previous</v-btn>
              <v-btn rounded color="primary" @click="e1 = 4">Continue</v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card flat height="150px">
              <v-card-title style="font-size:16px;"><span style="color: #0471A5;">Masukan Keyword Baru</span></v-card-title>
              <v-col cols="12" sm="3" md="3">
                <v-text-field outlined dense label="Keyword baru"></v-text-field>
              </v-col>
            </v-card>

            <v-divider></v-divider>
            <div class="mt-4">
              <v-btn class="mx-2" outlined rounded color="primary" @click="e1 = 3">Previous</v-btn>
              <v-btn rounded color="primary" @click="e1 = 5">Continue</v-btn>
            </div>
          </v-stepper-content>

          <v-stepper-content step="5">
            <v-card flat height="200px">
              <v-alert icon="mdi-checkbox-marked-circle-outline" prominent text dense type="info">
                Proses Selesai! Anda telah berhasil.
              </v-alert>
              <v-col cols="12" sm="12" md="12">
                <p>Anda telah berhasil melakukan:</p>
                <p>Penambahan Keyword Untuk User Role Pada Group Keyword bencana</p>
              </v-col>
            </v-card>

            <v-divider></v-divider>
            <div class="mt-4">
              <v-btn rounded color="primary">Finish</v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
</template>

<script>
  export default {
    data: () => ({
      groupkeyword: [
        'Teh', 
        'Bencana',
        'Gempa',
        ],
        e1: 1,
        page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Keyword Manager',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Keyword Wizzard',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      
    }),
  }
</script>
